import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

const Close = ({ color, onClick, style, pathStyle, inputMode, className }) => (
  <div
    className={`box exit-search-logo${color ? ` ${color}-background-exit` : ''}${inputMode ? ' with-border' : ''}${
      className ? ` ${className}` : ''
    }`}
    style={style}
    onClick={onClick}
  >
    <svg viewBox='0 0 40 40'>
      <path style={pathStyle} className='close-x' d='M 10,10 L 30,30 M 30,10 L 10,30' />
    </svg>
  </div>
)

Close.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
  style: PropTypes.object,
  pathStyle: PropTypes.object,
  inputMode: PropTypes.bool
}

export default Close
